import { useContext } from 'react';

import type { ApplicationContextType } from './context';
import { ApplicationContext } from './context';

export const useApplicationContext = (): ApplicationContextType => {
    return useContext(ApplicationContext);
};
